import { ReadOnlyCartDirective } from './directives/readOnlyCartDirective';

export const SummaryModule = angular
    .module('oo.checkout.summary', [])
    .directive('readOnlyCart', ReadOnlyCartDirective)
    .name;
